import styled from "@emotion/styled";
import { Menu, MenuItem } from "react-aria-components";

export const StyledMenu = styled(Menu)`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  min-width: 176px;
  width: max-content;
  max-width: 90vw;

  [data-mds-name="mds-menu-item-tooltip-trigger"] {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    min-width: 0;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  min-width: 0;
`;
